module.exports = __webpack_public_path__ + "img/mediagirl_2022.db89466a.jpg";